import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Container, Header, Segment, List } from "semantic-ui-react";
import { useStore } from "../../../stores/store";

interface Props {
  onNavigateNext: () => void;
}

export default function PreSurveyHomePage({ onNavigateNext }: Props) {
  const { t } = useTranslation("common");
  const { commonStore } = useStore();

  const content_en = (
    <>
      <Segment inverted color="blue" className="survey-intro-header">
        <Header as="h1"> About RefleCT</Header>
      </Segment>
      <div className="pre-post-txt">
        <strong>RefleCT - (Reflection of e-Competencies of Teachers),</strong> is a tool for teachers to
        reflect on their competence to use digital technologies for teaching and learning. It consists of
        32 questions subdivided into 6 key areas of digital competence.
      </div>
      <List bulleted style={{ paddingLeft: "20px" }}>
        <List.Item>Professional Engagement</List.Item>
        <List.Item>Digital Resources</List.Item>
        <List.Item>Teaching and learning</List.Item>
        <List.Item>Assessment</List.Item>
        <List.Item>Empowering learners</List.Item>
        <List.Item>Facilitating learners’ digital competence</List.Item>
      </List>
      <div className="pre-post-txt">
        <strong>RefleCT </strong>is based on the Digital Competence Framework for Educators (DigCompEdu)
        and SELFIE-for-Teachers tool developed by the European Commission’s Joint Research Centre. It was
        further adapted by a group of international and national experts of the Asian Development Bank to
        meet the context of Uzbek teachers.
      </div>
    </>
  );

  const content_uz = (
    <>
      <Segment inverted color="blue" className="survey-intro-header">
        <Header as="h1"> RefleCT haqida</Header>
      </Segment>
      <div className="pre-post-txt">
        <strong>RefleCT - (O'qituvchilarning raqamli kompetentsiyalarini baholash)</strong> bu
        o'qituvchilarning ta’lim berish va ta’lim olish uchun raqamli texnologiyalardan foydalanish
        kompetentsiyalarini baholashlari mumkin bo'lgan vositadir. U raqamli kompetentsiyaning 6 ta
        asosiy sohasiga boʻlingan 32 ta savoldan iborat.
      </div>
      <List bulleted style={{ paddingLeft: "20px" }}>
        <List.Item>Professional faoliyat</List.Item>
        <List.Item>Raqamli resurslar</List.Item>
        <List.Item>Ta’lim berish va ta’lim olish </List.Item>
        <List.Item>Baholash</List.Item>
        <List.Item>O‘quvchilarning imkoniyatlarini kengaytirish</List.Item>
        <List.Item>O‘quvchilarning raqamli kompetentsiyasini rivojlantirishga ko‘maklashish</List.Item>
      </List>
      <div className="pre-post-txt">
        <strong>RefleCT vositasi </strong>Yevropa Komissiyasining Qo‘shma tadqiqot markazi (JRC)
        tomonidan ishlab chiqilgan o‘qituvchilar uchun Raqamli Kompetentlik asoslari (DigCompEdu) va
        SELFIE vositasi asosida yaratilgan. Vosita Osiyo Taraqqiyot Bankining xalqaro va mahalliy
        mutaxassislar guruhi tomonidan Oʻzbekistondagi oʻqituvchilarning ehtiyojlari va talablariga
        moslashtirildi.
      </div>
    </>
  );

  const content_ru = (
    <>
      <Segment inverted color="blue" className="survey-intro-header">
        <Header as="h1">О RefleCTе</Header>
      </Segment>
      <div className="pre-post-txt">
        <strong>RefleCT - (Оценка е-компетенций учителей)</strong> - это инструмент, с помощью которого
        учителя могут оценить свою компетентность в использовании цифровых технологий для преподавания и
        обучения. Он состоит из 32 вопросов, разделенных на 6 ключевых областей цифровой компетенции.
      </div>
      <List bulleted style={{ paddingLeft: "20px" }}>
        <List.Item>Профессиональная деятельность</List.Item>
        <List.Item>Цифровые ресурсы</List.Item>
        <List.Item>Преподавание и обучение</List.Item>
        <List.Item>Оценивание</List.Item>
        <List.Item>Расширение возможностей учащихся</List.Item>
        <List.Item>Содействие развитию цифровой компетентности учащихся</List.Item>
      </List>
      <div className="pre-post-txt">
        <strong>RefleCT </strong> основан на Рамках Цифровой Компетентности для Учителей (DigCompEdu) и
        инструменте SELFIE-for-Teachers, разработанном Объединенным исследовательским центром Европейской
        комиссии. В дальнейшем он был адаптирован группой международных и национальных экспертов
        Азиатского банка развития с учетом потребностей учителей Узбекистана.
      </div>
    </>
  );

  return (
    <>
      {commonStore.lang === "en" && content_en}
      {commonStore.lang === "uz" && content_uz}
      {commonStore.lang === "ru" && content_ru}
      <Container className="survey-btns">
        <Segment>
          <Button
            primary
            floated="right"
            content={t("Common.Next")}
            onClick={() => {
              onNavigateNext();
            }}
          ></Button>
        </Segment>
      </Container>
    </>
  );
}
